import AgencyHelper, { AgencyConstants } from 'features/Agency/agencyHelper';
import ChargeHelper from 'features/Charge/chargeHelper';
import CustomDateRangePicker, {
  dateFilter,
  getDateFilterOption,
} from 'general/components/Others/CustomDateRangePicker';
import DashboardChartCard from 'general/components/quybka/Cards/DashboardChartCard';
import BarChart from 'general/components/quybka/Charts/BarChart';
import AppResource from 'general/constants/AppResource';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import moment from 'moment';
import PropTypes from 'prop-types';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import AgencyDashboardHeaderView from '../../components/AgencyDashboardHeaderView';
import useAppConfig from 'hooks/useAppConfig';
import KTTooltip from 'general/components/OtherKeenComponents/KTTooltip';
import AppColors from 'general/constants/AppColors';
import DropdownFilterTable from 'general/components/DropdownFilterTable';
import KTDropdownFilter from 'general/components/OtherKeenComponents/KTDropdownFilter';
import imgEmptyNoData from 'assets/images/img_emptyview_no_data.png';
import EmptyView from 'general/components/Others/EmptyView';
import CustomCardMore from 'general/components/Others/CustomCardMore';
import AppRoute from 'general/constants/AppRoute';
import CustomDropdown2 from 'general/components/Others/CustomDropdown2';

GroupDashboardScreen.propTypes = {
  agencyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

function GroupDashboardScreen({ agencyId, ...props }) {
  // MARK: ---- PROPERTIES ----
  const chartRef = useRef();
  const appConfig = useAppConfig();
  const [agencyDetail, setAgencyDetail] = useState(null);
  useEffect(() => {
    if (Utils.isValid(agencyId)) {
      AgencyHelper.API.requestAgencyDetail(agencyId).then((response) => {
        setAgencyDetail(response);
      });
    }
  }, [agencyId]);
  // thong tin tru sac
  const [chargePointStatistic, setChargePointStatistic] = useState({
    total: 0,
    charging: 0,
    connected: 0,
  });
  // thong tin he thong
  const [systemStatistic, setSystemStatistic] = useState({
    totalEnergy: 0, // san luong dien trong ngay
    totalPower: 0, // cong suat tuc thi cua he thong
    totalTransactions: 0, // tong so phien sac trong ngay
    totalChargeDuration: 0, // tong thoi gian sac trong ngay
  });
  useEffect(() => {
    requestGetRealtimeData();
    const timer = setInterval(() => {
      requestGetRealtimeData();
    }, 5000);
    return () => {
      clearInterval(timer);
    };
  }, []);
  const [chartData, setChartData] = useState({});
  const [chartFilter, setChartFilter] = useState({
    from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
    to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
    selectedValue: dateFilter.baMuoiNgayGanNhat,
  });
  useEffect(() => {
    ChargeHelper.API.Dashboard.requestGetDailyData({
      from: chartFilter.from,
      to: chartFilter.to,
    }).then((res) => {
      setChartData(res ?? {});
    });
  }, [chartFilter]);
  useEffect(() => {
    setEnergyFilter({ ...chartFilter, energyType: energyType });
    setTransactionFilter({ ...chartFilter, transactionType: transactionType });
  }, [chartFilter])

  const processVehicleData = (data) => {
    if (!data) return;
    const transactionCount = {
      CAR: [],
      BIKE: []
    };
    const totalRevenue = {
      CAR: [],
      BIKE: []
    };
    const totalEnergy = {
      CAR: [],
      BIKE: []
    };

    data?.forEach(day => {
      const date = day.date;

      const carData = day.vehicleTypes.find(v => v.vehicleType === "CAR");
      const bikeData = day.vehicleTypes.find(v => v.vehicleType === "BIKE");

      transactionCount.CAR.push({
        date: date,
        transactions: carData.transactionCount || 0
      });
      transactionCount.BIKE.push({
        date: date,
        transactions: bikeData.transactionCount || 0
      });

      totalRevenue.CAR.push({
        date: date,
        amount: carData.totalRevenue || 0
      });
      totalRevenue.BIKE.push({
        date: date,
        amount: bikeData.totalRevenue || 0
      });

      totalEnergy.CAR.push({
        date: date,
        energy: carData.totalEnergy || 0
      });
      totalEnergy.BIKE.push({
        date: date,
        energy: bikeData.totalEnergy || 0
      });
    });

    return {
      transactionCount,
      totalRevenue,
      totalEnergy
    };
  }

  const chartDataByVehicle = useMemo(() => {
    return processVehicleData(chartData?.dailyByVehicleType);
  }, [chartData])

  const getDataByType = (type, vehicleType, chartData, chartDataByVehicle) => {
    const typeMap = {
      transaction: {
        '': chartData?.transactionByDate,
        BIKE: chartDataByVehicle?.transactionCount?.BIKE,
        CAR: chartDataByVehicle?.transactionCount?.CAR
      },
      energy: {
        '': chartData?.energyByDate,
        BIKE: chartDataByVehicle?.totalEnergy?.BIKE,
        CAR: chartDataByVehicle?.totalEnergy?.CAR
      },
      revenue: {
        '': chartData?.revenueByDate,
        BIKE: chartDataByVehicle?.totalRevenue?.BIKE,
        CAR: chartDataByVehicle?.totalRevenue?.CAR
      }
    };

    return typeMap[type]?.[vehicleType] || null;
  };

  const [energyType, setEnergyType] = useState('');
  const [energyFilter, setEnergyFilter] = useState({ ...chartFilter, energyType: energyType });
  // dien sac theo ngay
  const chartEnergyByDateEl = useMemo(() => {
    const energyByDate = getDataByType('energy', energyType, chartData, chartDataByVehicle);
    if (!energyByDate) return;
    let labels = energyByDate?.map((item) => Utils.formatDateTimeToString(item.date, 'DD'));
    let data = energyByDate?.map((item) => ((item.energy ?? 0) / 1000).toFixed(3));
    if (energyByDate?.length > 31) {
      const groupedData = _.groupBy(energyByDate, (item) => moment(item.date).format('MM/YYYY'));
      labels = Object.keys(groupedData);
      data = labels?.map((label) => {
        const total = groupedData[label]?.reduce((sum, item) => sum + item.energy, 0);
        return (total / 1000).toFixed(3);
      });
    }

    return (
      <DashboardChartCard
        title="Thống kê điện sạc"
        name="Tổng"
        value={
          Utils.formatNumber(data?.reduce((sum, item) => _.toNumber(sum) + _.toNumber(item), 0)) +
          ' kWh'
        }
        valueColor="rgba(41, 132, 238, 1)"
        actionEl={
          <DropdownFilterTable
            id="energyType"
            isLightButton={true}
            toggleElementBorderRadius={10}
            filterComponent={[
              <div className="col-12 p-0">
                <KTDropdownFilter
                  label="Loại điện sạc"
                  filterKey="energyType"
                  options={[
                    { name: 'Tất cả', value: '' },
                    ...ChargeHelper.Data.vehicleTypeOptions,
                  ]}
                  selectedValue={energyFilter.energyType}
                  handleChange={(value) => {
                    setEnergyFilter({ ...energyFilter, energyType: value });
                  }}
                />
              </div>,
              <div className="col-12 p-0">
                <label htmlFor="filterByDate" className="mb-0 mr-2 font-weight-bolder">
                  Khoảng thời gian thống kê
                </label>
                <CustomDateRangePicker
                  alignRight={true}
                  toggleFontWeight="600"
                  toggleElementBorderRadius={5}
                  initialValue={energyFilter.selectedValue}
                  onPressSave={(selectedValue, startDate, endDate) => {
                    setEnergyFilter({
                      ...energyFilter,
                      from: startDate,
                      to: endDate,
                      selectedValue: selectedValue,
                    });
                  }}
                />
              </div>
            ]}
            resetDefaultTable={() => {
              const updateChartFilter = {
                ...chartFilter,
                from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
                to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
                selectedValue: dateFilter.baMuoiNgayGanNhat,
              };
              setEnergyFilter({ ...updateChartFilter, energyType: '' });
              setEnergyType('');
              setChartFilter(updateChartFilter);
            }}
            saveFilter={() => {
              const { energyType, ...dateFilter } = energyFilter;
              setChartFilter(dateFilter);
              setEnergyType(energyType);
            }}
            isDefaultFilter={Utils.checkDefaultFilter(
              ['selectedValue', 'from', 'to'],
              { ...chartFilter, energyType },
              dateFilter.baMuoiNgayGanNhat,
            )}
          />
        }
        chartEl={
          <BarChart
            title="Điện sạc"
            unit="kWh"
            labels={labels}
            data={data}
            color="rgba(41, 132, 238, 0.4)"
            hoverColor="rgba(41, 132, 238, 1)"
          />
        }
      />
    );
  }, [chartDataByVehicle, chartData, chartFilter, energyFilter, energyType]);
  // doanh thu theo ngay
  const chartRevenueByDateEl = useMemo(() => {
    const revenueByDate = chartData?.revenueByDate ?? [];
    let labels = revenueByDate.map((item) => Utils.formatDateTimeToString(item.date, 'DD'));
    let data = revenueByDate.map((item) => (item.amount ?? 0) / 1000000);

    if (revenueByDate.length > 31) {
      const groupedData = _.groupBy(revenueByDate, (item) => moment(item.date).format('MM/YYYY'));
      labels = Object.keys(groupedData);
      data = labels.map((label) => {
        const total = groupedData[label].reduce((sum, item) => sum + item.amount, 0);
        return (total / 1000000).toFixed(3);
      });
    }

    return (
      <DashboardChartCard
        title="Thống kê doanh thu"
        name="Tổng"
        value={
          Utils.formatNumber(data.reduce((sum, item) => _.toNumber(sum) + _.toNumber(item), 0)) +
          ' triệu'
        }
        valueColor="rgba(48, 189, 111, 1)"
        actionEl={
          <CustomDateRangePicker
            alignRight={true}
            toggleFontWeight="600"
            toggleElementBorderRadius={10}
            initialValue={chartFilter.selectedValue}
            onPressSave={(selectedValue, startDate, endDate) => {
              setChartFilter({
                from: startDate,
                to: endDate,
                selectedValue: selectedValue,
              });
            }}
          />
        }
        chartEl={
          <BarChart
            title="Doanh thu"
            unit="triệu"
            labels={labels}
            data={data}
            color="rgba(48, 189, 111, 0.4)"
            hoverColor="rgba(48, 189, 111, 1)"
            showLine={true}
          />
        }
      />
    );
  }, [chartDataByVehicle, chartData, chartFilter]);
  const [transactionType, setTransactionType] = useState('');
  const [transactionFilter, setTransactionFilter] = useState({ ...chartFilter, transactionType: transactionType });
  // phien sac theo ngay
  const chartTransactionByDateEl = useMemo(() => {
    const transactionByDate = getDataByType('transaction', transactionType, chartData, chartDataByVehicle);
    if (!transactionByDate) return;
    let labels = transactionByDate?.map((item) => Utils.formatDateTimeToString(item.date, 'DD'));
    let data = transactionByDate?.map((item) => item.transactions ?? 0);

    if (transactionByDate?.length > 31) {
      const groupedData = _.groupBy(transactionByDate, (item) =>
        moment(item.date).format('MM/YYYY')
      );
      labels = Object.keys(groupedData);
      data = labels?.map((label) => {
        const total = groupedData[label]?.reduce((sum, item) => sum + item.transactions, 0);
        return total;
      });
    }

    return (
      <DashboardChartCard
        title="Thống kê phiên sạc"
        name="Tổng"
        value={
          Utils.formatNumber(data?.reduce((sum, item) => _.toNumber(sum) + _.toNumber(item), 0)) +
          ' phiên sạc'
        }
        valueColor="rgba(88, 86, 214, 1)"
        actionEl={
          <DropdownFilterTable
            id="transactionType"
            isLightButton={true}
            toggleElementBorderRadius={10}
            filterComponent={[
              <div className="col-12 p-0">
                <KTDropdownFilter
                  label="Loại phiên sạc"
                  filterKey="transactionType"
                  options={[
                    { name: 'Tất cả', value: '' },
                    ...ChargeHelper.Data.vehicleTypeOptions,
                  ]}
                  selectedValue={transactionFilter.transactionType}
                  handleChange={(value) => {
                    setTransactionFilter({ ...transactionFilter, transactionType: value });
                  }}
                />
              </div>,
              <div className="col-12 p-0">
                <label htmlFor="filterByDate" className="mb-0 mr-2 font-weight-bolder">
                  Khoảng thời gian thống kê
                </label>
                <CustomDateRangePicker
                  alignRight={true}
                  toggleFontWeight="600"
                  toggleElementBorderRadius={5}
                  initialValue={transactionFilter.selectedValue}
                  onPressSave={(selectedValue, startDate, endDate) => {
                    setTransactionFilter({
                      ...transactionFilter,
                      from: startDate,
                      to: endDate,
                      selectedValue: selectedValue,
                    });
                  }}
                />
              </div>
            ]}
            resetDefaultTable={() => {
              const updateChartFilter = {
                ...chartFilter,
                from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
                to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
                selectedValue: dateFilter.baMuoiNgayGanNhat,
              };
              setTransactionFilter({ ...updateChartFilter, transactionType: '' });
              setTransactionType('');
              setChartFilter(updateChartFilter);
            }}
            saveFilter={() => {
              const { transactionType, ...dateFilter } = transactionFilter;
              setChartFilter(dateFilter);
              setTransactionType(transactionType);
            }}
            isDefaultFilter={Utils.checkDefaultFilter(
              ['selectedValue', 'from', 'to'],
              { ...chartFilter, transactionType },
              dateFilter.baMuoiNgayGanNhat,
            )}
          />
        }
        chartEl={
          <BarChart
            title="Phiên sạc"
            unit="phiên sạc"
            labels={labels}
            data={data}
            color="rgba(88, 86, 214, 0.4)"
            hoverColor="rgba(88, 86, 214, 1)"
          />
        }
      />
    );
  }, [chartDataByVehicle, chartData, chartFilter, transactionFilter, transactionType]);
  // khach hang theo ngay
  const chartActiveUsersByDateEl = useMemo(() => {
    const activeUsersByDate = chartData?.activeUsersByDate ?? [];
    let labels = activeUsersByDate.map((item) => Utils.formatDateTimeToString(item.date, 'DD'));
    let data = activeUsersByDate.map((item) => item.activeUsers ?? 0);

    if (activeUsersByDate.length > 31) {
      const groupedData = _.groupBy(activeUsersByDate, (item) =>
        moment(item.date).format('MM/YYYY')
      );
      labels = Object.keys(groupedData);
      data = labels.map((label) => {
        const total = groupedData[label].reduce((sum, item) => sum + item.activeUsers, 0);
        return total;
      });
    }

    return (
      <DashboardChartCard
        title="Thống kê khách hàng"
        name="Tổng"
        value={
          Utils.formatNumber(data.reduce((sum, item) => _.toNumber(sum) + _.toNumber(item), 0)) +
          ' khách hàng'
        }
        valueColor="rgba(253, 112, 139, 1)"
        actionEl={
          <CustomDateRangePicker
            alignRight={true}
            toggleFontWeight="600"
            toggleElementBorderRadius={10}
            initialValue={chartFilter.selectedValue}
            onPressSave={(selectedValue, startDate, endDate) => {
              setChartFilter({
                from: startDate,
                to: endDate,
                selectedValue: selectedValue,
              });
            }}
          />
        }
        chartEl={
          <BarChart
            title="Khách hàng"
            unit="khách hàng"
            labels={labels}
            data={data}
            color="rgba(253, 112, 139, 0.4)"
            hoverColor="rgba(253, 112, 139, 1)"
          />
        }
      />
    );
  }, [chartData, chartFilter]);
  // khach hang moi theo ngay
  const chartNewUsersByDateEl = useMemo(() => {
    const newUsersByDate = chartData?.newUsersByDate ?? [];
    let labels = newUsersByDate?.map((item) => Utils.formatDateTimeToString(item.date, 'DD'));
    let data = newUsersByDate?.map((item) => item.newUsers ?? 0);

    if (newUsersByDate?.length > 31) {
      const groupedData = _.groupBy(newUsersByDate, (item) => moment(item.date).format('MM/YYYY'));
      labels = Object.keys(groupedData);
      data = labels?.map((label) => {
        const total = groupedData[label]?.reduce((sum, item) => sum + item.newUsers, 0);
        return total;
      });
    }

    return (
      <div ref={chartRef}>
        <DashboardChartCard
          title="Thống kê khách hàng"
          name="Tổng"
          value={
            Utils.formatNumber(data?.reduce((sum, item) => _.toNumber(sum) + _.toNumber(item), 0)) +
            ' khách hàng'
          }
          valueColor="rgba(253, 112, 139, 1)"
          actionEl={
            <CustomDateRangePicker
              alignRight={true}
              toggleFontWeight="600"
              toggleElementBorderRadius={10}
              initialValue={chartFilter.selectedValue}
              onPressSave={(selectedValue, startDate, endDate) => {
                setChartFilter({
                  from: startDate,
                  to: endDate,
                  selectedValue: selectedValue,
                });
              }}
            />
          }
          chartEl={
            <BarChart
              title="Khách hàng mới"
              unit="khách hàng"
              labels={labels}
              data={data}
              color="rgba(253, 112, 139, 0.4)"
              hoverColor="rgba(253, 112, 139, 1)"
            />
          }
        />
      </div>
    );
  }, [chartData, chartFilter]);
  // thong tin dau tu
  const [investmentReportData, setInvestmentReportData] = useState({});
  useEffect(() => {
    if (Utils.isValid(agencyId)) {
      AgencyHelper.API.requestGetInvestmentReport({
        agencyId,
        date: moment().format('YYYY-MM-DD'),
      }).then((response) => {
        console.log({ response });
        setInvestmentReportData(response);
      });
    }
  }, [agencyId]);

  const [monthlyGroupCommission, setMonthlyGroupCommission] = useState({});
  useEffect(() => {
    if (!agencyId || !appConfig.groupAgencyId) return;
    ChargeHelper.API.Dashboard.requestGetMonthlyGroupCommission({
      groupAgencyId: appConfig.groupAgencyId,
      month: moment().format('YYYY-MM'),
    }).then((res) => {
      const filterRes = res?.filter((item) => item?.agencyId === agencyId) ?? {};
      setMonthlyGroupCommission(filterRes);
    });
  }, [agencyId, appConfig.groupAgencyId]);

  // doi soat NĐT HTKD
  const [groupReconciliation, setGroupReconciliation] = useState([]);
  useEffect(() => {
    if (!agencyId) return;
    AgencyHelper.API.requestGetReconciliationList({
      agencyId: agencyId,
      forRole: AgencyConstants.AgencyRole.GROUP,
    }).then((res) => {
      setGroupReconciliation(res?.reconciliations);
    });
  }, [agencyId]);

  // thong bao he thong
  const [filterSystemLog, setFilterSystemLog] = useState({
    page: 0,
    limit: 10,
    selectedValue: dateFilter.baMuoiNgayGanNhat,
    from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
    to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
    stationId: '',
    agencyId: agencyId,
  });
  const [filterSystemLogDropdown, setFilterSystemLogDropdown] = useState({
    page: 0,
    limit: 10,
    selectedValue: dateFilter.baMuoiNgayGanNhat,
    from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
    to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
    stationId: '',
    agencyId: agencyId,
  });
  const [selectedChargeStationSystemLog, setSelectedChargeStationSystemLog] = useState(null);
  const [systemLogList, setSystemLogList] = useState([]);
  const [totalSystemLog, setTotalSystemLog] = useState(0);

  useEffect(() => {
    const params = _.pickBy(
      filterSystemLog,
      (value) => value !== null && value !== undefined && value !== ''
    );
    ChargeHelper.API.SystemLog.requestGetSystemLogList(params)
      .then((response) => {
        setSystemLogList((prevList) => {
          if (filterSystemLog?.page !== 0) {
            const existingIds = new Set(prevList.map(item => item.messageId));
            const newUnique = (response?.messages ?? []).filter(
              item => !existingIds.has(item.messageId)
            );

            return [...prevList, ...newUnique];
          } else {
            return response?.messages ?? [];
          }
        });

        setTotalSystemLog(response?.total ?? 0);
      })
      .catch((error) => {
        console.error("Lỗi khi lấy system log:", error);
      });
  }, [filterSystemLog]);

  const filterChargeStationSystemLogEl = useMemo(() => {
    return (
      <CustomDropdown2
        id="stationId_filter"
        name="stationId_filter"
        toggleElement={
          <button
            className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between`}
            type="button"
          >
            {selectedChargeStationSystemLog?.name ?? 'Chọn trạm sạc'}
          </button>
        }
        selectedValue={selectedChargeStationSystemLog}
        dropdownMenuItems={[{ name: 'Trạm sạc', role: 'STATION' }]}
        subTitleType="address"
        getSubItems={async (item) => {
          return ChargeHelper.API.requestGetChargeStationList({
            page: item?.page || 0,
            limit: 10,
            q: item?.q || '',
          }).then((data) => {
            return {
              values: data.chargeStations?.map((station) => ({
                id: station?.stationId,
                name: station?.name,
                item: station,
                address: ChargeHelper.Utils.getChargeStationFullAddress(station),
              })),
              total: data.total,
            };
          });
        }}
        dropdownMenuStyle={{ maxHeight: '30vh' }}
        dropdownMenuClassName="overflow-auto w-100"
        onChange={(value) => {
          setSelectedChargeStationSystemLog(value);
          setFilterSystemLogDropdown({
            ...filterSystemLogDropdown,
            stationId: value?.id,
          });
        }}
        isDropdownForm={true}
        titleSearchable={true}
        searchable={true}
        searchFormClassName="mx-3 my-1 search-form-border"
        ignoreConfirmClick={true}
        defaultValue={{
          name: 'Trạm sạc',
          role: 'STATION',
        }}
        footerEl={
          <div
            className="p-4 position-sticky sticky-bottom bg-white"
            style={{
              borderTop: `1px solid ${AppColors.gray[300]}`,
            }}
          >
            {UIHelper.buildNegativeButton('Bỏ chọn', () => {
              setSelectedChargeStationSystemLog(null);
              setFilterSystemLogDropdown({
                ...filterSystemLogDropdown,
                stationId: '',
              });
            })}
          </div>
        }
        direction='dropup'
      />
    );
  }, [selectedChargeStationSystemLog]);

  // MARK: ---- METHODS ----
  const requestGetRealtimeData = useCallback(() => {
    ChargeHelper.API.Dashboard.requestGetRealtimeData().then((res) => {
      setChargePointStatistic({
        total: res?.totalChargePoint ?? 0,
        charging: res?.chargingChargePoint ?? 0,
        connected: res?.connectedChargePoint ?? 0,
      });
      setSystemStatistic({
        totalEnergy: res?.totalEnergy ?? 0,
        totalPower: res?.totalPower ?? 0,
        totalTransactions: res?.totalTransactions ?? 0,
        totalChargeDuration: res?.totalChargeDuration ?? 0,
      });
    });
  }, []);

  const GroupReconciliationTable = (data) => {
    const textHeader = ['Tháng', 'Số tiền'];

    const contents = data?.map(item => ({
      name: `Tháng ${Utils.formatDateTimeToString(item?.month, 'MM/YYYY')}`,
      value: (item?.totalRevenue || 0) - (item?.taxAmount || 0)
    })) || [];

    let html = `
    <div>
      Mức doanh thu của những tháng chưa ký đối soát.
      <div class="row m-0 position-relative py-2 bg-white rounded-lg">
        <div class="rounded-lg p-0" style="border: 1px solid #EBEDEF">
          <table class="w-100" style="border-collapse: collapse">
            <thead>
              <tr style="background-color: #F7F7FD; font-size: 12px; color: #494968">
  `;

    textHeader.map((header, index) => {
      const align = index === 0 ? 'text-left' : 'text-right';
      const minWidth = index === 0 ? '200px' : '100px';
      html += `
      <th class="p-3 ${align}" style="min-width: ${minWidth}; font-weight: bold; padding: 12px 16px;">
        ${header}
      </th>`;
    });

    html += `
              </tr>
            </thead>
            <tbody>`;

    if (contents.length > 0) {
      contents.forEach(row => {
        html += `
      <tr style="border-top: 1px solid #EBEDEF">
        <td class="p-3 text-left" style="padding: 12px 16px;">${row.name ?? '--'}</td>
        <td class="p-3 text-right" style="padding: 12px 16px;">
          ${Utils.formatNumber(row.value)} VNĐ
        </td>
      </tr>`;
      });
    } else {
      html += `
      <tr>
        <td colspan="2" class="p-3 text-center">Không có dữ liệu để hiển thị</td>
      </tr>`;
    }

    html += `
            </tbody>
          </table>
        </div>
      </div>
    </div>`;

    return html;
  };

  return (
    <div className="mt-4" style={{ minHeight: '1200px' }}>
      {/* header */}
      <div className="px-4">
        <AgencyDashboardHeaderView
          name={agencyDetail?.name}
          role="Nhà đầu tư HTKD"
          contentEl={
            <div className="px-4 d-flex flex-column gap-3 mt-4">
              {UIHelper.buildStatisticItem(
                'rgba(118, 154, 255, 1)',
                <div className="d-flex align-items-center gap-2">Số tiền đã đầu tư</div>,
                `${Utils.formatNumber(Math.round(investmentReportData?.totalAsset)) ?? 0} VNĐ`,
                null,
                'fa-solid fa-chart-line-up'
              )}
              {appConfig.showShareRatio ? UIHelper.buildStatisticItem(
                'rgba(255, 166, 63, 1)',
                <div className="d-flex align-items-center gap-2">
                  Tỷ lệ vốn góp được hưởng, tính đến hiện tại{' '}
                  <KTTooltip
                    text={`<div><span>Tỷ lệ được bắt đầu tính kể từ tháng N+1 (tháng N là tháng NĐT tham gia góp vốn)</span></div>`}
                    textHeader="Tỷ lệ vốn góp được hưởng, tính đến hiện tại"
                    isHtmlContent
                  >
                    <i
                      className="fa-regular fa-info-circle"
                      style={{ color: AppColors.primary }}
                    />
                  </KTTooltip>
                </div>,
                `${Utils.formatNumber((investmentReportData?.effectiveShare * 100)?.toFixed(3) ?? 0)}%`,
                null,
                'fa-solid fa-badge-percent'
              ) : <></>}
              {UIHelper.buildStatisticItem(
                '#FD7497',
                <div className="d-flex align-items-center gap-2">
                  Doanh thu dự kiến trong tháng{' '}
                  <KTTooltip
                    text={GroupReconciliationTable(
                      groupReconciliation?.filter(r => r?.status !== 'COMPLETED')
                    )}
                    textHeader="Doanh thu dự kiến"
                    isHtmlContent
                  >
                    <i className="fa-regular fa-info-circle" style={{ color: AppColors.primary }} />
                  </KTTooltip>
                </div>,
                `${Utils.formatNumber(Math.round(_.sumBy(monthlyGroupCommission, 'energyCommission')) ?? 0)} VNĐ`,
                AppResource.icons.icExpectedRevenue,
                null
              )}
              {UIHelper.buildStatisticItem(
                'rgba(48, 189, 111, 1)',
                'Tổng doanh thu đã nhận',
                `${Utils.formatNumber(investmentReportData?.earned) ?? 0} VNĐ`,
                null,
                'fa-solid fa-chart-mixed'
              )}
            </div>
          }
        />
      </div>

      {/* thong ke */}
      <div className="mt-4">
        <div className="px-4">
          {UIHelper.buildCard(
            <div className="">
              <div className="row m-0 p-0 px-2 pt-4">
                {/* cong suat tuc thi he thong */}
                <div className="col-xl-3 col-lg-6 mb-4 px-2">
                  {UIHelper.buildStatisticItem(
                    '#00C7BE',
                    'Công suất tức thì của hệ thống',
                    `${Utils.isValid(systemStatistic?.totalPower)
                      ? Utils.formatNumber((systemStatistic?.totalPower / 1000).toFixed(3))
                      : 0
                    } kW`,
                    AppResource.icons.icTotalPower
                  )}
                </div>
                {/* san luong dien trong ngay */}
                <div className="col-xl-3 col-lg-6 mb-4 px-2">
                  {UIHelper.buildStatisticItem(
                    '#539FF8',
                    'Tổng sản lượng điện trong ngày',
                    `${Utils.isValid(systemStatistic?.totalEnergy)
                      ? Utils.formatNumber((systemStatistic?.totalEnergy / 1000).toFixed(3))
                      : 0
                    } kWh`,
                    AppResource.icons.icTotalEnergy
                  )}
                </div>
                {/* so phien sac trong ngay */}
                <div className="col-xl-3 col-lg-6 mb-4 px-2">
                  {UIHelper.buildStatisticItem(
                    '#7876E5',
                    'Tổng số phiên sạc trong ngày',
                    `${Utils.isValid(systemStatistic?.totalTransactions)
                      ? Utils.formatNumber(systemStatistic?.totalTransactions)
                      : 0
                    } phiên`,
                    AppResource.icons.icTotalTransactions
                  )}
                </div>
                {/* tong thoi gian sac trong ngay */}
                <div className="col-xl-3 col-lg-6 mb-4 px-2">
                  {UIHelper.buildStatisticItem(
                    '#7AD661',
                    'Tổng thời gian sạc trong ngày',
                    Utils.isValid(systemStatistic?.totalChargeDuration)
                      ? Utils.convertSecondsToHText(systemStatistic?.totalChargeDuration)
                      : '',
                    AppResource.icons.icTotalDuration
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* bieu do */}
      <div className="mt-4">
        <div className="row m-0 p-0 px-2">
          {/* thong ke dien sac */}
          <div className="col-lg-6 px-2 mb-4">{chartEnergyByDateEl}</div>
          {/* thong ke doanh thu */}
          {/* <div className="col-lg-6 px-2 mb-4">{chartRevenueByDateEl}</div> */}
          {/* thong ke phien sac */}
          <div className="col-lg-6 px-2 mb-4">{chartTransactionByDateEl}</div>
          {/* thong ke khach hang */}
          <div className="col-lg-6 px-2 mb-4">{chartNewUsersByDateEl}</div>
          {/* thong bao */}
          <div className="col-lg-6 px-2 mb-4">
            {UIHelper.buildCard(
              <div>
                <div className='d-flex justify-content-between'>
                  {UIHelper.buildCardHeader(
                    'Thông báo vận hành',
                    false,
                    null,
                    false,
                    true,
                    <span style={UIHelper.buildFontStyle('600', '13px', AppColors.gray[800])}>
                      Tổng:{' '}
                      <span style={{ color: AppColors.primary }}>
                        {Utils.formatNumber(totalSystemLog)} thông báo
                      </span>
                    </span>
                  )}
                  <div className='px-4 py-3'>
                    <DropdownFilterTable
                      id="systemLog"
                      isLightButton={true}
                      toggleElementBorderRadius={10}
                      filterComponent={[
                        <div className="col-12 pb-2 p-0">
                          {UIHelper.buildFormLabel('Trạm sạc')}
                          {filterChargeStationSystemLogEl}
                        </div>,
                        <div className="col-12 p-0">
                          <label htmlFor="filterByDate" className="mb-0 mr-2 font-weight-bolder">
                            Khoảng thời gian thống kê
                          </label>
                          <CustomDateRangePicker
                            alignRight={true}
                            toggleFontWeight="600"
                            toggleElementBorderRadius={5}
                            initialValue={filterSystemLogDropdown.selectedValue}
                            onPressSave={(selectedValue, startDate, endDate) => {
                              setFilterSystemLogDropdown({
                                ...filterSystemLogDropdown,
                                from: startDate,
                                to: endDate,
                                selectedValue: selectedValue,
                              });
                            }}
                            direction='dropup'
                          />
                        </div>
                      ]}
                      resetDefaultTable={() => {
                        const updateSystemLogFilter = {
                          ...filterSystemLog,
                          from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
                          to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
                          selectedValue: dateFilter.baMuoiNgayGanNhat,
                          stationId: '',
                        };
                        setSelectedChargeStationSystemLog(null);
                        setFilterSystemLogDropdown(updateSystemLogFilter);
                        setFilterSystemLog(updateSystemLogFilter);
                      }}
                      saveFilter={() => {
                        setFilterSystemLog(filterSystemLogDropdown);
                      }}
                      isDefaultFilter={Utils.checkDefaultFilter(
                        ['selectedValue', 'from', 'to', 'page', 'limit', 'agencyId'],
                        filterSystemLog,
                        dateFilter.baMuoiNgayGanNhat,
                      )}
                    />
                  </div>
                </div>
                {systemLogList?.length
                  ? (
                    <div className="px-4 mb-4">
                      <CustomCardMore
                        scrollTargetSelector=".system-log-scroll"
                        filter={filterSystemLog}
                        setFilter={setFilterSystemLog}
                        dataList={systemLogList}
                        dataTotal={totalSystemLog}
                        hasMore={systemLogList?.length < totalSystemLog}
                      >
                        <div
                          className="system-log-scroll"
                          style={{
                            maxHeight: '298px',
                            overflowY: 'auto',
                          }}
                        >
                          {systemLogList?.map((item, index) => {
                            return (
                              <div key={item?.messageId ?? index}>
                                {UIHelper.buildCellSystemInfo(
                                  <i
                                    className={`${ChargeHelper.Utils.getMessageLogTypeIcon(
                                      item?.level
                                    )} text-${ChargeHelper.Utils.getMessageLogTypeColor(item?.level)}`}
                                    style={{
                                      fontSize: '22px',
                                    }}
                                  />,
                                  item?.title,
                                  Utils.formatDateTimeToString(item?.createdAt, 'DD/MM/YYYY - HH:mm'),
                                  true,
                                  () => {
                                    Utils.openInNewTab(`${AppRoute.pointList}/${item?.pointId}`)
                                  }
                                )}
                              </div>
                            );
                          })}
                        </div>
                      </CustomCardMore>
                    </div>
                  ) : (
                    <EmptyView
                      icon={imgEmptyNoData}
                      title="Không có dữ liệu để hiển thị"
                      text={<span>Vui lòng kiểm tra kết nối mạng hoặc tải lại trang.</span>}
                    />
                  )}
              </div>,
              false,
              false,
              true,
              true
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default GroupDashboardScreen;
